import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailOptin", webpackPrefetch: true */ './lazyIndex');
});
var lazyInitializeMailOptinService = new LazyAction(lazyModule, function (m) { return m.initializeMailOptinService; });
runAfterInitialRender(function () {
    lazyInitializeMailOptinService.importAndExecute();
});
//# sourceMappingURL=index.js.map